import header from "./General CSS/Header.module.css";
import home from "./Images/home_icon.png";
import returnIcon from "./Images/return.png";
import React from "react";

export default function Header({page, returnLink, links = null}: {page: string, returnLink: string, links?: ParentIconProps[] | null}) {
    return (
        <div className={header.Header}>
            <div className={header.left}>
                <img className={header.icon} onClick={() => {window.location.href = returnLink}} src={returnIcon} alt="Return" />
                <h1>{page}</h1>
            </div>
            <div className={header.right}>
                {links && (
                    <nav>
                        {links.map((link, i) => (
                            <img key={i} className={header.icon} onClick={() =>
                            {window.location.href = link.href}} src={link.src} alt={link.alt} />
                            ))}
                    </nav>
                )}
                {/*<img className={header.icon} onClick={() => {*/}
                {/*    window.location.href = "/";*/}
                {/*}} src={home} alt="Home" />*/}
            </div>
        </div>
    )
}

type ParentIconProps = {
    src: string;
    href: string;
    alt?: string;
}